import type { ProductItemTilesStyle } from "./productItemTiles.tokens";

export function getBadgeText(style?: ProductItemTilesStyle) {
    switch (style) {
        case "clearance":
            return "Hot deal";
        case "signature":
            return "Signature";
        case "australian":
            return "Australian made";
        case "featured":
            return "Trending now";
        default:
            return "";
    }
}

export function getCtaText(ctaText?: string, title?: string) {
    const trimmedText = ctaText?.trim();
    if (trimmedText) return trimmedText;

    const trimmedTitle = title?.trim();
    if (trimmedTitle) return `View all ${trimmedTitle}`;

    return "View all products";
}

export function isValidCtaUrl(ctaUrl?: string) {
    return typeof ctaUrl === "string" && ctaUrl.trim().length > 0;
}
